import React from 'react';
import _get from 'lodash/get';
import _classNames from 'classnames';
import { Button, makeStyles } from '@material-ui/core';
import ArrowWhiteIcon from './images/ArrowUpRightWhiteIcon.svg';

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: 8,
    padding: '7px',
    ...theme.typography.pxSmall,
    textTransform: 'none',
    lineHeight: '18px',
    '& img, svg ': {
      marginLeft: 5,
    },
  },
}));

export const VisitSiteButton = ({
  className,
  siteCopy,
  clientDetails,
  onClick,
  title,
}) => {
  const classes = useStyles();
  const label = _get(
    siteCopy,
    'pageCopy.hybridLinkCardVisitSite',
    'Visit Site',
  );
  const customLabel = _get(clientDetails, 'metadata.customLinkCTA');

  return (
    <Button
      variant="contained"
      className={_classNames(className, classes.root)}
      onClick={onClick}
      color="primary"
      aria-label={title}
    >
      {customLabel || label}
      <img src={ArrowWhiteIcon} alt="" />
    </Button>
  );
};
